import React from 'react';

import SingleplayerNavigator from './SingleplayerNavigator';

const PlayNavigator = () => {
  return <SingleplayerNavigator />;
};

export default PlayNavigator;
